import React from 'react';
import { css } from '@emotion/react';

type EmailCardProps = {
  image: string;
  title: string;
  status: string;
};

const cardStyles = css`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow:
    0 1.98px 3.06px -0.36px rgba(0, 0, 0, 0.05),
    0 1px 1px -0.1px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: box-shadow 0.2s ease;
  width: 100%;

  &:hover {
    box-shadow:
      0 4px 12px -1px rgba(0, 0, 0, 0.08),
      0 2px 4px -0.5px rgba(0, 0, 0, 0.06);
  }
`;

const imageWrapperStyles = css`
  width: 100%;
  aspect-ratio: 342 / 339;
  overflow: hidden;
`;

const imageStyles = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const infoStyles = css`
  padding: 16px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const titleStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #241a17;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const badgeStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  height: 28px;
  border: 1px solid rgba(55, 49, 47, 0.2);
  border-radius: 112px;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 17.8px;
  color: rgba(61, 46, 41, 0.52);
  white-space: nowrap;
`;

export default function EmailCard({ image, title, status }: EmailCardProps) {
  return (
    <div css={cardStyles}>
      <div css={imageWrapperStyles}>
        <img css={imageStyles} src={image} alt={title} />
      </div>
      <div css={infoStyles}>
        <p css={titleStyles}>{title}</p>
        <div>
          <span css={badgeStyles}>{status}</span>
        </div>
      </div>
    </div>
  );
}
